import { StoreSummary } from 'types';

const getStoreRole = (storeSummary: StoreSummary): string =>
  String(storeSummary?.store?.user_role || '').toLowerCase();

export const getOperatorStores = (stores: StoreSummary[] = []): StoreSummary[] =>
  stores.filter((storeSummary) => getStoreRole(storeSummary) === 'operator');

export const getManagerStores = (stores: StoreSummary[] = []): StoreSummary[] =>
  stores.filter((storeSummary) => ['owner', 'manager'].includes(getStoreRole(storeSummary)));

export const isOperatorOnlyUser = (stores: StoreSummary[] = []): boolean =>
  stores.length > 0 && getOperatorStores(stores).length === stores.length;

export const getFirstOperatorStoreId = (stores: StoreSummary[] = []): string | null =>
  getOperatorStores(stores)[0]?.store?.id || null;
